<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/card-acceptor-config">Merchant Config</a></li>
              <li class="breadcrumb-item active" *ngIf="!creatingNew">Edit Merchant Config</li>
              <li class="breadcrumb-item active" *ngIf="creatingNew">Create New Merchant</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Config Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-12">
        <div class="card-box">

          <div *ngIf="raiseWarning">
            <ngb-alert [dismissible]="false">
              <strong>Warning!</strong> {{warning}}
            </ngb-alert>
          </div>

          <h4 class="header-title">Merchant Configs </h4>
          <div *ngIf="!creatingNew">Edit Merchant Config details for your current participant</div>
          <div *ngIf="creatingNew">Create new Merchant Config for your current participant</div>
          <br />
          <div class="row">
            <div class="col-12">
              <form [formGroup]="cardAcceptorForm" name="form" (ngSubmit)="save()" autocomplete="off">

                <div class="row form-horizontal">
                  <div class="col-md-6 form-horizontal px-3">

                    <div class="form-group row">
                      <label for="name" class="col-3 col-form-label">Configuration Name</label>
                      <div class="col-9">
                        <input class="form-control" id="name" formControlName="name" required placeholder="">
                        <ul *ngIf="submitted || cardAcceptorForm.controls.name.touched" class="parsley-errors-list filled">
                          <li *ngIf="cardAcceptorForm.controls.name.hasError('required')" class="parsley-required">Configuration name is required</li>
                        </ul>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="participantId" class="col-3 col-form-label">Participant Id</label>
                      <div class="col-9">
                        <input type="number" class="form-control" id="participantId" formControlName="participantId" placeholder="" disabled="disabled">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="terminalConfigType" class="col-3 col-form-label">Terminal Config Type</label>
                      <div class="col-9">
                        <ng-select2 id="terminalConfigType" formControlName="terminalConfigType" [data]="terminalConfigTypes1" [options]="select2options" placeholder="" (valueChanged)="updateForm()"></ng-select2>
                        <ul *ngIf="submitted || cardAcceptorForm.controls.terminalConfigType.touched" class="parsley-errors-list filled">
                          <li *ngIf="cardAcceptorForm.controls.terminalConfigType.hasError('required')" class="parsley-required">Terminal config type is required</li>
                        </ul>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="merchantActive" class="col-3 col-form-label">Merchant Active</label>
                      <div class="col-9">
                        <input type="checkbox" id="merchantActive" formControlName="merchantActive" placeholder="">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="currencyCode" class="col-3 col-form-label">Currency Code</label>
                      <div class="col-9">
                        <ng-select2 [data]="currencies" [options]="select2options" id="currencyCode" formControlName="currencyCode" placeholder="" required name="currencyCode"></ng-select2>
                        <ul *ngIf="submitted || cardAcceptorForm.controls.currencyCode.touched" class="parsley-errors-list filled">
                          <li *ngIf="cardAcceptorForm.controls.currencyCode.hasError('required')" class="parsley-required">Currency code is required</li>
                        </ul>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="country" class="col-3 col-form-label">Country</label>
                      <div class="col-9">
                        <ng-select2 id="country" formControlName="country" [data]="countries" [options]="select2options" required name="country"></ng-select2>
                        <ul *ngIf="submitted || cardAcceptorForm.controls.country.touched" class="parsley-errors-list filled">
                          <li *ngIf="cardAcceptorForm.controls.country.hasError('required')" class="parsley-required">Country is required</li>
                        </ul>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="cvsRetailerId" class="col-3 col-form-label">CVS Retailer Id</label>
                      <div class="col-9">
                        <input class="form-control" id="cvsRetailerId" formControlName="cvsRetailerId" placeholder="">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="defaultLang" class="col-3 col-form-label">Default Lang</label>
                      <div class="col-9">
                        <ng-select2 [options]="select2options" id="defaultLang" formControlName="defaultLang" [data]="languages" placeholder=""></ng-select2>
                        <ul *ngIf="submitted || cardAcceptorForm.controls.defaultLang.touched" class="parsley-errors-list filled">
                          <li *ngIf="cardAcceptorForm.controls.defaultLang.hasError('required')" class="parsley-required">Default language is required</li>
                        </ul>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="limitsClass" class="col-3 col-form-label">Limits Class</label>
                      <div class="col-9">
                        <ng-select2 id="limitsClass" formControlName="limitsClass" [data]="limitsClasses" [options]="select2options"></ng-select2>
                        <ul *ngIf="submitted || cardAcceptorForm.controls.limitsClass.touched" class="parsley-errors-list filled">
                          <li *ngIf="cardAcceptorForm.controls.limitsClass.hasError('required')" class="parsley-required">Limits class is required</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 form-horizontal px-3">

                    <div class="form-group row" *ngIf="displayTAContent">
                      <label for="merchantStatus" class="col-3 col-form-label">Merchant Status</label>
                      <div class="col-9">
                        <ng-select2 [options]="select2options" id="merchantStatus" formControlName="merchantStatus" [data]="taMerchantStatuses" placeholder=""></ng-select2>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="nui" class="col-3 col-form-label">NUI</label>
                      <div class="col-9">
                        <input class="form-control" id="nui" formControlName="nui" placeholder="nui">
                      </div>
                    </div>

                    <div class="form-group row" *ngIf="displayTAContent">
                      <label for="receiptGroupId" class="col-3 col-form-label">Receipt Group Id</label>
                      <div class="col-9">
                        <ng-select2 [options]="select2options" id="receiptGroupId" [(ngModel)]="receiptGroupId" formControlName="receiptGroupId" [data]="receiptGroups" placeholder=""></ng-select2>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="region" class="col-3 col-form-label">Region</label>
                      <div class="col-9">
                        <ng-select2 id="region" formControlName="region" [options]="select2options" [data]="regions"></ng-select2>
                        <ul *ngIf="submitted || cardAcceptorForm.controls.region.touched" class="parsley-errors-list filled">
                          <li *ngIf="cardAcceptorForm.controls.region.hasError('required')" class="parsley-required">Region is required</li>
                        </ul>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="routingGroup" class="col-3 col-form-label">Routing Group</label>
                      <div class="col-9">
                        <ng-select2 id="routingGroup" formControlName="routingGroup" [options]="select2options" [data]="routingGroups"></ng-select2>
                        <ul *ngIf="submitted || cardAcceptorForm.controls.routingGroup.touched" class="parsley-errors-list filled">
                          <li *ngIf="cardAcceptorForm.controls.routingGroup.hasError('required')" class="parsley-required">Routing Group is required</li>
                        </ul>
                      </div>
                    </div>

                    <div class="form-group row" *ngIf="!displayTAContent">
                      <label for="status" class="col-3 col-form-label">Status</label>
                      <div class="col-9">
                        <input class="form-control" id="status" formControlName="status" placeholder="">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="supportTeam" class="col-3 col-form-label">Support Team</label>
                      <div class="col-9">
                        <ng-select2 [options]="select2options" id="supportTeam" formControlName="supportTeam" placeholder="" [data]="supportTeams"></ng-select2>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="transactionThreshold" class="col-3 col-form-label">Transaction Threshold</label>
                      <div class="col-9">
                        <input type="number" class="form-control" id="transactionThreshold" formControlName="transactionThreshold" placeholder="">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="velocityPeriod" class="col-3 col-form-label">Velocity Period</label>
                      <div class="col-9">
                        <input type="number" class="form-control" id="velocityPeriod" formControlName="velocityPeriod" placeholder="">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="velocityThreshold" class="col-3 col-form-label">Velocity Threshold</label>
                      <div class="col-9">
                        <input type="number" class="form-control" id="velocityThreshold" formControlName="velocityThreshold" placeholder="">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="worstEventSeverity" class="col-3 col-form-label">Worst Event Severity</label>
                      <div class="col-9">
                        <input type="number" class="form-control" id="worstEventSeverity" formControlName="worstEventSeverity" placeholder="">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 form-horizontal px-6">
                    <div class="form-group row" *ngIf="!!createResult && createResult.success == false">
                      <div *ngIf="raiseDanger" style="width:100%">
                        <ngb-alert [dismissible]="false" type="danger">
                          <strong>Error!</strong> {{createResult.message}}
                        </ngb-alert>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-0 justify-content-end row">
                  <button type="button" *ngIf="canDelete" [style]="DeleteButton" class="btn btn-danger waves-effect waves-light float-left m-2" (click)="determineDeleteDialog()">
                    Delete  <i class="mdi mdi-delete-outline"></i>
                  </button>
                  <button type="submit" class="btn btn-info waves-effect waves-light float-right m-2" [style]="AddButton">Save <i class="mdi mdi-content-save"></i></button>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>






